import { initFriendlyCaptcha } from "./friendly-captcha";

const isCaptchaSolutionReady = (value) => {
  const solution = (value || "").trim();
  return solution !== "" && !solution.startsWith(".");
};

const waitForCaptchaSolution = (form, timeoutMs = 8000) =>
  new Promise((resolve) => {
    const startedAt = Date.now();

    const tick = () => {
      const solutionInput = form.querySelector('[name="frc-captcha-solution"]');
      if (isCaptchaSolutionReady(solutionInput?.value)) {
        resolve(true);
        return;
      }

      if (Date.now() - startedAt >= timeoutMs) {
        resolve(false);
        return;
      }

      window.setTimeout(tick, 150);
    };

    tick();
  });

export const initAuditForm = () => {
  initFriendlyCaptcha();

  document.querySelectorAll(".audit-teaser__form form").forEach((form) => {
    if (form.dataset.auditCaptchaInit === "1") {
      return;
    }
    form.dataset.auditCaptchaInit = "1";

    form.addEventListener("submit", async (event) => {
      if (form.dataset.auditCaptchaBypass === "1") {
        form.dataset.auditCaptchaBypass = "0";
        return;
      }

      const captchaWidget = form.querySelector(".frc-captcha");
      if (!captchaWidget) {
        return;
      }

      const solutionInput = form.querySelector('[name="frc-captcha-solution"]');
      if (isCaptchaSolutionReady(solutionInput?.value)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      initFriendlyCaptcha();

      const ready = await waitForCaptchaSolution(form);
      if (!ready) {
        return;
      }

      form.dataset.auditCaptchaBypass = "1";
      form.requestSubmit();
    });
  });
};
